export const CONFIRM_OWNER_MODAL_ACTIONS = {
  save: "save",
  update: "update",
  cancel: "cancel",
}

export const CONFIRM_OWNER_MODAL_EVENTS = {
  onCancel: "onCancel",
  onSaveOrUpdateOwner: "onSaveOrUpdateOwner",
};


